import React from 'react';
import SaveAndCancel, { SaveAndCancelProps } from './SaveAndCancel';
import { Typography } from '@material-ui/core';

const styles = {
    additem: {
        display: 'flex',
        justifyContent: 'space-between'
    },
};

export interface FormPageHeaderProps extends SaveAndCancelProps {
    title: string;
    update?: boolean;
}

export default (props: FormPageHeaderProps) => {

    return (
        <div style={styles.additem}>
          <Typography variant="h6" style={{fontWeight:'bold', color:"#112B42"}}>{ props.title }</Typography> 
          <SaveAndCancel update={props.update} saveHandler={props.saveHandler} cancelText={props.cancelText} cancelHandler={props.cancelHandler}/>
        </div>
    );
}